import React from 'react';
import WhatsApp from '../services/WhatsApp';
import { useI18n } from '../i18n/LanguageProvider';
import { contactInfo } from '../data/contactInfo';

const Footer = () => {
  const { t } = useI18n();
  const wa = WhatsApp.link(contactInfo.phone, 'Hello, I have a question about cleaning.');
  return (
    <footer className="footer">
      <div className="container grid-2">
        <div>
          <div style={{display:'flex', alignItems:'center', gap:12}}>
            <img src="/assets/logo.png" alt="Sparklean" style={{width:28, height:28}}/>
            <strong>Sparklean.care.plus</strong>
          </div>
          <p className="mt-2">{t('footer.tagline')}</p>
          <p className="muted mt-1">© {new Date().getFullYear()} Sparklean. {t('footer.rights')}</p>
        </div>
        <div>
          <p><strong>{t('footer.getInTouch')}</strong></p>
          <p className="muted">{t('contact.phoneLabel')}: {contactInfo.phone}</p>
          <p className="muted">{t('contact.emailLabel')}: {contactInfo.email}</p>
          <p className="mt-1">
            <a className="btn secondary" href={wa} target="_blank" rel="noreferrer">{t('footer.chat')}</a>
          </p>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
